export default __webpack_public_path__ + "static/logo-experian-2c108564c86d0b65336076616b44b886.svg";